export default "__VITE_ASSET__Dp9Of9gC__"